<template>
  <base-info-card title="Archives">
    <ul class="pl">
      <li
        v-for="archive in archives"
        :key="archive"
        class="mb-3"
        v-text="archive"
      />
    </ul>
  </base-info-card>
</template>

<script>
  export default {
    name: 'NewsArchives',

    data: () => ({
      archives: [],
    }),

    watch: {
      '$i18n.locale'() {
        this.loadArchives()
      },
    },

    async mounted() {
      await this.loadArchives()
    },

    methods: {
      formatMonth(value) {
        if (!value) return ''
        const parts = value.split('-')
        if (parts.length < 2) return value
        return `${parts[0]}-${parts[1]}`
      },
      async loadArchives() {
        try {
          const resp = await this.$axios({
            method: 'get',
            url: '/public/blog',
            params: { lang: this.$i18n.locale, page: 1, size: 50 },
          })
          const items = (resp && resp.items) ? resp.items : (resp || [])
          const map = {}
          items.forEach(item => {
            const key = this.formatMonth(item.publishAt || '')
            if (!key) return
            map[key] = (map[key] || 0) + 1
          })
          this.archives = Object.keys(map)
            .sort((a, b) => (a > b ? -1 : 1))
            .map(key => `${key} (${map[key]})`)
        } catch (error) {
          this.archives = []
        }
      },
    },
  }
</script>
